export default function SecBtn(props){
    return(
        <button className="secbtn">
            {props.btntext}
        </button>
    )
}